const CatalogModelMixin = {
  methods: {
    getCatalogModel(id, locale) {
      const url = route("public.api.models.show", {
        model: id,
        locale: locale,
      });
      return axios.get(url);
    },

    getCatalogModelGallery(id) {
      const url = route("public.api.models.gallery", { model: id });
      return axios.get(url);
    },

    getCatalogModels(brand_id, params = {}) {
      const url = route("public.api.brands.models.index", { brand: brand_id });
      return axios.get(url, {
        params: params,
      });
    },
  },
};

export default CatalogModelMixin;
